import type { Service } from '~publish/legacy/constants/services/ServiceDefinitions'

/**
 * Services that Community plans to support but hasn't shipped yet.
 *
 * When a service is in this list:
 * - In the connect-channels grid: the tile renders disabled, with a "Coming
 *   soon" badge and no connect action.
 * - In the single-channel empty state: shows the "{Name} coming soon" copy
 *   variant with the branded icon bubble.
 *
 * Empty today — every service the backend exposes is fully supported. Add a
 * service here to flip it to coming-soon mode.
 */
export const COMING_SOON_SERVICES: readonly Service[] = []

export function isComingSoonService(
  service: string,
  allowlist: readonly Service[] = COMING_SOON_SERVICES,
): boolean {
  return allowlist.some((allowedService) => allowedService === service)
}
